import { configureStore } from '@reduxjs/toolkit';
import SignInReducer from '../features/signIn/signInSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import profsReducer from '../features/prof/profsSlice';
import classroomsReducer from '../features/classrooms/classroomsSlice';


export const store = configureStore({
  reducer: {
    signIn: SignInReducer,
    dashboard: dashboardReducer,
    profs: profsReducer,
    classrooms: classroomsReducer,
  },
});
